import { useQueryClient } from '@tanstack/react-query';

import { useWishListStore } from '@/data';
import { GProduct } from '@/types';

function useWishList() {
  const [state, setState] = useWishListStore();
  const queryClient = useQueryClient();
  const favProductsIds = state.fav_products;

  const addFav = (id: string) => {
    setState({ fav_products: [...favProductsIds, id] });
  };

  const removeFav = (id: string) => {
    const newProducts = favProductsIds.filter(product => product !== id);

    setState({ fav_products: newProducts });

    queryClient.setQueriesData(
      { queryKey: ['productsByIds'], exact: false },
      (oldData: GProduct[]) => {
        if (!Array.isArray(oldData)) {
          return oldData;
        }

        return oldData.filter(product => product?.id !== id);
      },
    );
  };

  return { addFav, favProductsIds, removeFav };
}

export default useWishList;
